/** Standard disclaimer block for all Lumina Flash Report views. */
import { Warning } from "@phosphor-icons/react";

export default function FlashDisclaimer() {
  return (
    <div
      data-testid="flash-disclaimer"
      className="mt-6 border-l-2 border-[#94A3B8] bg-[#EEEEEE] rounded-r-md p-5 print:border-l print:border-stone-400 print:bg-white print:break-inside-avoid"
    >
      <div className="flex items-start gap-3">
        <Warning size={16} weight="duotone" className="text-[#475569] shrink-0 mt-0.5 print:hidden" />
        <div>
          <p className="uppercase text-[11px] tracking-[0.2em] text-[#475569] font-medium mb-1.5">
            Important · Unreconciled Data Notice
          </p>
          <p className="text-[11px] leading-relaxed text-[#334155] font-serif">
            FLASH provides a real-time operational snapshot from live, unreconciled
            daily transaction feeds. Because it is optimised for immediate speed and decision-making,
            these metrics are subject to rolling changes unverified by Prysm Financial. As such,
            daily/weekly margins and supplier spend tables may reflect timing discrepancies or
            pending invoice match adjustments. They do not constitute verified financial statements
            and will fluctuate until standard month-end bank reconciliations are completed.
          </p>
        </div>
      </div>
    </div>
  );
}
